import React, { FC, ReactElement } from 'react';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import MenuItem from '@mui/material/MenuItem';
import { uuid4 } from '@sentry/utils';
// Component
import Text from '../text';
import AvatarText from '../avatars';
import menuContent, { MenuInfos } from './menuContent';
// Resources
import { stringsRes } from '../../resources/strings';
import Space, { Type } from '../layout/space';

interface DrawerAdminMenuProps {
    onClick?: () => void;
}

// TODO: remove and move style to drawerMenu
const DrawerAdminMenu: FC<DrawerAdminMenuProps> = ({ onClick }): ReactElement => {
    const menuEntries: MenuInfos[] = menuContent.menuAdminBuilder({ isAdmin: true });
    const classes = useStyles();

    const renderMenu = (data: MenuInfos[]): JSX.Element[] => {
        const { pathname } = window.location;
        return data.map((menu: MenuInfos): JSX.Element => {
            return (
                <Link
                    {...{
                        onClick,
                        component: RouterLink,
                        to: menu.href,
                        color: 'white',
                        style: { textDecoration: 'none' },
                    }}
                    key={`${menu.label}-${uuid4()}`}
                    underline="none"
                >
                    <MenuItem className={menu.href === pathname ? classes.selected : classes.selectedVariant}>
                        <div className={classes.drawerMenuRowContainer}>
                            {menu.icon}
                            <div className={classes.content}>
                                <Text.ShortMediumText16 text={menu.label} color="white" />
                                {menu.description && (
                                    <div className={classes.descriptionContent}>
                                        <Text.Overline text={menu.description} />
                                        <Space type={Type.horizontal} value={0.5} />
                                        <AvatarText title={stringsRes.common.perso} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </MenuItem>
                </Link>
            );
        });
    };

    return <div className={classes.drawerMenuRoot}>{renderMenu(menuEntries)}</div>;
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        drawerMenuRoot: {
            overflow: 'hidden',
        },
        selected: {
            backgroundColor: '#87888D33!important',
            borderRadius: '4px 0px 0px 4px',
        },
        selectedVariant: {
            '&:hover': {
                backgroundColor: '#87888D33!important',
                borderRadius: '4px 0px 0px 4px',
            },
        },
        drawerMenuRowContainer: {
            flexDirection: 'row',
            display: 'flex',
            width: '100%',
            paddingTop: 20,
            paddingBottom: 20,
            alignItems: 'center',
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            marginLeft: theme.spacing(2),
        },
        descriptionContent: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        },
    }),
);

export default DrawerAdminMenu;
